import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed bottom-0 bg-white w-full" }
const _hoisted_2 = { class: "flex justify-between max-w-[40rem] mx-auto p-5" }
const _hoisted_3 = ["href"]

import { useRoute } from "vue-router"
  import { computed } from "vue"
  import { searchOutline, personCircleOutline, earthOutline, businessOutline, briefcaseOutline, bookOutline } from "ionicons/icons"
  import { useUserStore } from "@/store/user"
  import { IonFooter } from "@ionic/vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'FooterComponent',
  setup(__props) {

  const route = useRoute()
  const user = useUserStore()

  /**
   * generate profile url
   */
  const getURL = () => {
    let fullName = user.customerDetails.profile.name.full_name
    if (!fullName || fullName.length === 0) {
      fullName = `${user.customerDetails.profile.name.first_name} ${user.customerDetails.profile.name.last_name}`
    }
    return fullName.toLowerCase().replaceAll(" ", "-")
  }

  const option = computed(() => [
    {
      name: "resources",
      icon: bookOutline,
      link: "/resources",
    },
    {
      name: "jobs",
      icon: briefcaseOutline,
      link: "/job-board",
    },
    {
      name: "discover",
      icon: businessOutline,
      link: "/",
    },
    {
      name: "world",
      icon: earthOutline,
      link: "/workbean-world",
    },
    {
      name: "search",
      icon: searchOutline,
      link: "/search",
    },
    {
      name: "profile",
      icon: personCircleOutline,
      link: !localStorage.getItem("WBSAASAPP_TK") ? "/login" : user.customerDetails.profile.user_id.length ? `/talent-profile/${user.customerDetails.profile.user_id}` : "/details",
    },
  ])

return (_ctx: any,_cache: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createBlock(_unref(IonFooter), {
    class: "ion-no-border",
    collapse: "fade",
    mode: "ios"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(option), (options) => {
            return _withDirectives((_openBlock(), _createElementBlock("li", {
              key: `${options}_id`
            }, [
              _createElementVNode("a", {
                href: options.link,
                class: _normalizeClass(["flex flex-col items-center", _unref(route).fullPath === options.link ? 'text-primary-violet' : ' text-primary-black'])
              }, [
                _createVNode(_component_ion_icon, {
                  class: "text-3xl",
                  icon: options.icon
                }, null, 8, ["icon"]),
                _createElementVNode("span", {
                  class: _normalizeClass(["text-[12px] capitalize", { 'font-bold': _unref(route).fullPath === options.link }])
                }, _toDisplayString(options.name), 3)
              ], 10, _hoisted_3)
            ])), [
              [_vShow, options.auth !== null]
            ])
          }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}
}

})